import List from "../../containers/Bookings/List";
import Entry from "../../containers/Bookings";

const bookingRoutes = [
  {
    path: "/bookings",
    exact: true,
    auth: true,
    component: List
  },
  {
    path: "/bookings/:type",
    exact: true,
    auth: true,
    component: Entry
  },
  {
    path: "/bookings/:type/:id",
    exact: true,
    auth: true,
    component: Entry
  }
];

export default bookingRoutes;



// WEBPACK FOOTER //
// ./src/routes/modules/bookings.jsx